export const auditOperationLabels: Record<string, string> = {
  // Project operations
  PROJECT_CREATED: 'Project Created',
  PROJECT_UPDATED: 'Project Updated',
  PROJECT_DELETED: 'Project Deleted',
  PROJECT_RENAMED: 'Project Renamed',
  PROJECT_COMPLAINT_EMAIL_UPDATED: 'Project Complaint Email Updated',
  PROJECT_CSL_STYLE_UPDATED: 'Project CSL Style Updated',
  PROJECT_MEMBER_ADDED: 'Project Member Added',
  PROJECT_MEMBER_REMOVED: 'Project Member Removed',
  PROJECT_REVIEW_CREATED: 'Review Created',

  // Review operations
  REVIEW_RENAMED: 'Review Renamed',
  REVIEW_REORDERED: 'Review Reordered',
  REVIEW_ROLLBACKED: 'Review Rolled Back',
  REVIEW_DELETED: 'Review Deleted',
  REVIEW_LOCKED: 'Review Locked',
  REVIEW_UNLOCKED: 'Review Unlocked',
  REVIEW_UPDATED: 'Review Updated',
  REVIEW_VERSION_NAME_UPDATED: 'Review Version Name Updated',

  // Review Plan operations
  REVIEW_PLAN_LOCKED: 'Review Plan Locked',
  REVIEW_PLAN_UNLOCKED: 'Review Plan Unlocked',
  REVIEW_PLAN_EVALUATOR_CREATED: 'Evaluator Created',
  REVIEW_PLAN_EVALUATOR_REMOVED: 'Evaluator Removed',
  REVIEW_PLAN_EVALUATOR_UPDATED: 'Evaluator Updated',
  REVIEW_PLAN_SYNTHESIS_UPDATED: 'Synthesis Settings Updated',
  REVIEW_PLAN_ATTRIBUTE_STRUCTURED_UPDATED: 'Attribute Structure Updated',
  REVIEW_PLAN_DATA_EXTRACTION_ATTRIBUTE_ADDED:
    'Data Extraction Attribute Added',
  REVIEW_PLAN_ATTRIBUTE_STRUCTURE_DELETED: 'Attribute Structure Deleted',
  REVIEW_PLAN_SEARCH_STRATEGY_SUMMARY_UPDATED:
    'Search Strategy Summary Updated',
  REVIEW_PLAN_PICO_INCLUSION_CRITERIA_ENABLED:
    'PICO Inclusion Criteria Enabled',
  REVIEW_PLAN_PICO_INCLUSION_CRITERIA_DISABLED:
    'PICO Inclusion Criteria Disabled',
  REVIEW_PLAN_INCLUSION_CRITERION_ADDED: 'Inclusion Criterion Added',
  REVIEW_PLAN_INCLUSION_CRITERION_DELETED: 'Inclusion Criterion Deleted',
  REVIEW_PLAN_PICO_INCLUSION_CRITERION_ADDED: 'PICO Inclusion Criterion Added',
  REVIEW_PLAN_PICO_INCLUSION_CRITERION_DELETED:
    'PICO Inclusion Criterion Deleted',
  REVIEW_PLAN_EVIDENCE_LEVEL_INCLUSION_CRITERIA_ENABLED:
    'Evidence Level Criteria Enabled',
  REVIEW_PLAN_EVIDENCE_LEVEL_INCLUSION_CRITERIA_DISABLED:
    'Evidence Level Criteria Disabled',
  REVIEW_PLAN_INCLUSION_CRITERIA_EVIDENCE_LEVEL_UPDATED:
    'Evidence Level Updated',
  REVIEW_PLAN_INCLUSION_CRITERIA_TIME_LIMIT_UPDATED: 'Time Limit Updated',
  REVIEW_PLAN_TITLE_AND_ABSTRACT_SCREENING_ENABLED:
    'Title & Abstract Screening Enabled',
  REVIEW_PLAN_TITLE_AND_ABSTRACT_SCREENING_DISABLED:
    'Title & Abstract Screening Disabled',
  REVIEW_PLAN_TITLE_AND_ABSTRACT_CRITERION_ADDED:
    'Title & Abstract Criterion Added',
  REVIEW_PLAN_TITLE_AND_ABSTRACT_CRITERION_DELETED:
    'Title & Abstract Criterion Deleted',
  REVIEW_PLAN_FULL_TEXT_CRITERION_ADDED: 'Full Text Criterion Added',
  REVIEW_PLAN_FULL_TEXT_CRITERION_DELETED: 'Full Text Criterion Deleted',
  REVIEW_PLAN_STUDIES_APPRAISAL_OXFORD_LEVEL_OF_EVIDENCE_ENABLED:
    'Oxford Level of Evidence Enabled',
  REVIEW_PLAN_STUDIES_APPRAISAL_OXFORD_LEVEL_OF_EVIDENCE_DISABLED:
    'Oxford Level of Evidence Disabled',
  REVIEW_PLAN_STUDIES_APPRAISAL_ENABLED: 'Studies Appraisal Enabled',
  REVIEW_PLAN_STUDIES_APPRAISAL_DISABLED: 'Studies Appraisal Disabled',
  REVIEW_PLAN_APPRAISAL_CRITERIA_ADDED: 'Appraisal Criteria Added',
  REVIEW_PLAN_APPRAISAL_CRITERIA_DELETED: 'Appraisal Criteria Deleted',
  REVIEW_PLAN_CUSTOM_IMPORT_SOURCE_ADDED: 'Custom Import Source Added',
  REVIEW_PLAN_SEARCH_IMPORTED: 'Search Imported',
  REVIEW_PLAN_SEARCH_DELETED: 'Search Deleted',
  REVIEW_PLAN_IMPORT_SOURCE_DELETED: 'Import Source Deleted',
  REVIEW_PLAN_INCLUSION_TIME_LIMIT_ENABLED: 'Time Limit Enabled',
  REVIEW_PLAN_INCLUSION_TIME_LIMIT_DISABLED: 'Time Limit Disabled',

  // Review Execute operations
  REVIEW_EXECUTE_MARK_STUDY_AS_DUPLICATED: 'Study Marked as Duplicated',
  REVIEW_EXECUTE_MARK_STUDY_AS_NOT_DUPLICATED: 'Study Marked as Not Duplicated',
  REVIEW_EXECUTE_FULL_TEXT_SCREENING_APPLIED: 'Full Text Screening Applied',
  REVIEW_EXECUTE_IMPORT_CITATION_SEARCH: 'Citation Search Imported',
  REVIEW_EXECUTE_STUDY_UPDATED: 'Study Updated',
  REVIEW_EXECUTE_COMPLAINT_SUBMITTED: 'Complaint Submitted',
  REVIEW_EXECUTE_MARK_STUDY_AS_FAVORITED: 'Study Favorited',
  REVIEW_EXECUTE_MARK_STUDY_AS_UNFAVORITED: 'Study Unfavorited',
  REVIEW_EXECUTE_STUDY_PDF_FILE_UPLOADED: 'PDF File Uploaded',
  REVIEW_EXECUTE_STUDY_PDF_FILE_DELETED: 'PDF File Deleted',
  REVIEW_EXECUTE_STUDY_OXFORD_LEVEL_OF_EVIDENCE_UPDATED:
    'Oxford Level of Evidence Updated',
  REVIEW_EXECUTE_STUDY_OXFORD_LEVEL_OF_EVIDENCE_RESETED:
    'Oxford Level of Evidence Reset',
  REVIEW_EXECUTE_STUDY_APPRAISED: 'Study Appraised',
  REVIEW_EXECUTE_STUDY_APPRAISAL_CLEARED: 'Study Appraisal Cleared',
  REVIEW_EXECUTE_STUDY_SYNTHESIS_FINALIZED: 'Study Synthesis Finalized',
  REVIEW_EXECUTE_STUDY_SYNTHESIS_UNFINALIZED: 'Study Synthesis Unfinalized',
  REVIEW_EXECUTE_ATTRIBUTE_SYNTHESIS_FINALIZED: 'Attribute Synthesis Finalized',
  REVIEW_EXECUTE_ATTRIBUTE_SYNTHESIS_UNFINALIZED:
    'Attribute Synthesis Unfinalized',
  REVIEW_EXECUTE_TITLE_AND_ABSTRACT_SCREENING_UPDATED:
    'Title & Abstract Screening Updated',
  REVIEW_EXECUTE_TITLE_AND_ABSTRACT_SCREENING_DELETED:
    'Title & Abstract Screening Deleted',
  REVIEW_EXECUTE_FULL_TEXT_SCREENING_DELETED: 'Full Text Screening Deleted',
  REVIEW_EXECUTE_STUDY_ABSTRACT_UPDATED: 'Study Abstract Updated',
  REVIEW_EXECUTE_AI_ATTRIBUTE_SUGGESTION_CLEARED:
    'AI Attribute Suggestion Cleared',

  // Review Item operations
  REVIEW_ITEM_STUDY_QUESTION_ANSWERED: 'Study Question Answered',
  REVIEW_ITEM_ATTRIBUTE_HIGHLIGHT_ADDED: 'Attribute Highlight Added',
  REVIEW_ITEM_ATTRIBUTE_HIGHLIGHT_DELETED: 'Attribute Highlight Deleted',
  REVIEW_ITEM_SCREENING_HIGHLIGHT_ADDED: 'Screening Highlight Added',
  REVIEW_ITEM_SCREENING_HIGHLIGHT_DELETED: 'Screening Highlight Deleted',
}

export function formatAuditOperation(operation: string): string {
  if (operation in auditOperationLabels) {
    return auditOperationLabels[operation]
  }

  // Fallback: convert SNAKE_CASE to Title Case
  return operation
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase())
}
